window.app = window.app || {};

window.app.productPage = {
  el: {
    section: document.querySelector('.mt-product'),
    title: document.querySelector('.mt-product__title'),
    mainPrices: document.querySelector('.mt-product__prices'),
    prices: document.querySelectorAll('.mt-product .mt-prices'),
    offer: {
      section: document.querySelectorAll('.mt-product .mt-form-offer'),
      checkbox: document.querySelectorAll('.mt-product .mt-form-offer__checkbox input')
    },
    thumbs: document.querySelector('.mt-product-thumbs .swiper'),
    thumbItems: document.querySelectorAll('.mt-product-thumbs .swiper-slide'),
    thumbButtons: document.querySelectorAll('.mt-product-thumbs__button'),
    galleryWrapper: document.querySelector('.mt-product-gallery-wrapper'),
    mainGallery: document.querySelector('.mt-product-gallery .swiper'),
    staticGallery: document.querySelector('.mt-product-static-gallery'),
    accordions: document.querySelectorAll('.mt-product-details .mt-accordion'),
    accordionTabs: document.querySelectorAll('.mt-product-tabs__tab'),
    productForm: document.querySelector('.mt-product .mt-product-form'),
    productFormId: document.querySelector('.mt-product .mt-product-form input[name="id"]'),
    productFormBtn: document.querySelector('.mt-product .mt-product-form .mt-btn[type="submit"]'),
    stickyProductForm: document.querySelector('.mt-sticky-product-form'),
    stickyProductFormBtn: document.querySelector('.mt-sticky-product-form .mt-btn'),
    whatsInBundle: document.querySelector('.mt-whats-in-bundle'),
    bisSection: document.querySelector('.klaviyo-bis'),
    bisVariant: document.querySelector('.klaviyo-bis__fields input[name="variant"]'),
    customBtns: document.querySelectorAll('.mt-product-cta'),
    podsSelector: {
      form: document.querySelector('.mt-pods-selector'),
      formBtn: document.querySelector('.mt-pods-selector__action .mt-btn'),
      details: document.querySelector('.mt-pods__details'),
      detailsSummary: document.querySelector('.mt-pods-step--pods .mt-pods-step__summary-info'),
      options: document.querySelectorAll('.mt-pods__option input'),
      memberships: document.querySelectorAll('.mt-pods-membership'),
      membershipsToggle: document.querySelectorAll('.mt-pods-membership__toggle'),
      membershipsOption: document.querySelectorAll('.mt-pods-membership__checkbox input'),
      accessories: document.querySelector('.mt-accessories'),
      accessoriesItems: document.querySelectorAll('.mt-accessories__item'),
      courses: document.querySelector('.mt-courses'),
      coursesItems: document.querySelectorAll('.mt-courses__item'),
      step: {
        all: document.querySelectorAll('.mt-pods-step'),
        pods: document.querySelector('.mt-pods-step--pods'),
        memberships: document.querySelector('.mt-pods-step--membership'),
        accessories: document.querySelector('.mt-pods-step--accessories'),
        courses: document.querySelector('.mt-pods-step--courses'),
      },
      btn: {
        pods: document.querySelector('.mt-pods .mt-pods-step__summary .mt-btn'),
        memberships: document.querySelector('.mt-pods-memberships .mt-pods-step__summary .mt-btn')
      }
    },
    variantSelector: {
      options: document.querySelectorAll('.mt-product-option__list input')
    },
    reviewsSummary: document.querySelector('.mt-product__reviews button.mt-rating'),
  },
  slider: {},

  updatePrice: function () {
    const _this = this;
    const withDecimals = window.Shopify.money_format;
    if (!_this.el.mainPrices || _this.el.mainPrices.dataset.price === undefined) return;

    let price = _this.el.mainPrices.dataset.price;
    let compareAtPrice = (_this.el.mainPrices.dataset.compareAtPrice !== undefined) ? _this.el.mainPrices.dataset.compareAtPrice : null;
    let formattedPrice = Shopify.formatMoney(_this.el.mainPrices.dataset.price, withDecimals).replace('.00', '');
    let formattedCAP = (_this.el.mainPrices.dataset.compareAtPrice !== undefined) ? Shopify.formatMoney(_this.el.mainPrices.dataset.compareAtPrice, withDecimals).replace('.00', '') : null;
    let pricesHtml = '';

    // Default price
    if (compareAtPrice !== null) {
      pricesHtml = `<span class="mt-price mt-price--sale">${formattedPrice}</span><s class="mt-price mt-price--old">${formattedCAP}</s>`;
    } else {
      pricesHtml = `<span class="mt-price">${formattedPrice}</span>`;
    }

    // With offer/s
    if (_this.el.offer.section.length > 0 && _this.el.offer.checkbox.length > 0) {
      let anyOfferActive = false;
      let totalPrice = Number(_this.el.mainPrices.dataset.price);
      let totalCompareAtPrice = Number(_this.el.mainPrices.dataset.compareAtPrice) || totalPrice;

      _this.el.offer.section.forEach(offerSection => {
        const offerCheckbox = offerSection.querySelector('.mt-form-offer__checkbox input');
        if (offerSection.dataset.offerActive == 'true') {
          totalPrice += Number(offerCheckbox.dataset.price);
          totalCompareAtPrice += Number(offerCheckbox.dataset.compareAtPrice || offerCheckbox.dataset.price);
          anyOfferActive = true;
        }
      });

      if (anyOfferActive) {
        price = totalPrice;
        compareAtPrice = totalCompareAtPrice;
        formattedPrice = Shopify.formatMoney(totalPrice, withDecimals).replace('.00', '');
        formattedCAP = Shopify.formatMoney(totalCompareAtPrice, withDecimals).replace('.00', '');
  
        if (totalCompareAtPrice > totalPrice) {
          pricesHtml = `<span class="mt-price mt-price--sale">${formattedPrice}</span><s class="mt-price mt-price--old">${formattedCAP}</s>`;
        } else {
          pricesHtml = `<span class="mt-price">${formattedPrice}</span>`;
        }
      }
    }

    _this.el.mainPrices.dataset.totalPrice = price;
    _this.el.mainPrices.dataset.totalCompareAtPrice = compareAtPrice;
    _this.el.prices.forEach(priceEl => (priceEl.innerHTML = pricesHtml));
    app.productPage.updateAffirmPrice();
  },

  updateAffirmPrice: function () {
    const affirmEls = document.querySelectorAll('.affirm-as-low-as');
    const price = app.productPage.el.mainPrices.dataset.totalPrice;

    affirmEls.forEach(el => el.dataset.amount = price);
    if (typeof affirm === 'object') affirm?.ui?.refresh?.();

    setTimeout(() => {
      const updatedAffirmEls = document.querySelectorAll('.affirm-as-low-as');
      const isVisible = Array.from(updatedAffirmEls).some(el => el.innerText);
      if (!isVisible && typeof initializePromos === 'function') {
        if (typeof affirm === 'object') affirm?.ui?.refresh?.();
      }
    }, 500);
  },

  podsSelector: {
    currentStep: 1,

    form: function () {
      const _this = app.productPage;
      _this.el.podsSelector.form.addEventListener('submit', e => {
        e.preventDefault();

        const miniCart = document.querySelector('.mt-mini-cart');
        const formData = { items: [] };
        const items = [];
        const bundleId = `#${Math.random().toString(36).slice(2, 7)}`;
        const bundleIdQ = `#${Math.random().toString(36).slice(2, 7)}`;

        _this.el.podsSelector.formBtn.disabled = true;
        _this.el.podsSelector.formBtn.classList.add('mt-btn--loading');

        // Main product
        const mainProduct = document.querySelector('.mt-pods__option input:checked');
        if (mainProduct) {
          items.push({
            id: Number(mainProduct.value),
            quantity: 1
          });
        }

        // Additional membership
        const membership = document.querySelector('.mt-pods-membership__checkbox input:checked');
        if (membership && membership.value != 0) {
          items[0].properties = { _bundleId: bundleId, _itemType: 'product-main' };
          items.push({
            id: Number(membership.value),
            selling_plan: Number(membership.dataset.sellingPlan),
            quantity: 1,
            properties: {
              _bundleId: bundleId,
              _bundleIdQ: bundleIdQ,
              _itemEditable: false,
              _itemRemovable: true,
              _sellingPlan: Number(membership.dataset.sellingPlan)
            }
          });
        }

        // Additional products
        const otherProducts = document.querySelectorAll('.mt-accessories__item.active, .mt-courses__item.active');
        if (otherProducts.length > 0) {
          otherProducts.forEach(product => {
            const input = product.querySelector('.mt-quantity__input');
            const productData = {
              id: Number(input.dataset.variant),
              quantity: Number(input.value),
              properties: {
                _upsellFor: bundleId,
                _byokUpsell: true
              }
            };
            if (product.dataset.course == 'true') {
              items[0].properties = { _bundleId: bundleId, _itemType: 'product-main' };
              productData.properties = {
                ...productData.properties,
                _bundleId: bundleId,
                _bundleIdQ: bundleIdQ
              }
            }
            items.push(productData);
          });
          items[0].properties = { ...items[0].properties, _byokUpsell: true };
        }

        // Add to cart
        formData.items = items.reverse();

        // Prepare DataLayer products
        const productsToAdd = [];
        if (mainProduct && mainProduct.dataset.product) productsToAdd.push(mainProduct.dataset.product);
        if (membership && membership.value != 0 && membership.dataset.product) productsToAdd.push(membership.dataset.product);
        otherProducts.forEach(el => {
          const input = el.querySelector('.mt-quantity__input');
          if (input && input.dataset.product) {
            const productData = JSON.parse(input.dataset.product);
            productData.quantity = Number(input.value);
            productsToAdd.push(JSON.stringify(productData));
          }
        });

        if (miniCart && app.productForm.resolveBehavior(miniCart) === 'mini-cart') {
          formData.sections = 'mt-mini-cart';
          const addToCart = () => {
            app.cart.updateView(formData, 'add', () => {
              miniCart.classList.add('active');
              miniCart.setAttribute('aria-hidden', false);
              setTimeout(() => miniCart.classList.add('visible'), 50);
              if (_this.el.podsSelector.formBtn !== null) {
                _this.el.podsSelector.formBtn.disabled = false;
                _this.el.podsSelector.formBtn.classList.remove('mt-btn--loading');
              }

              app.dl.addedToCart(...productsToAdd);
            });
          };

          if (app.discounts.hasMembership(formData.items)) {
            app.discounts.apply(app.discounts.membershipDiscountCode, addToCart);
          } else {
            addToCart();
          }
        } else {
          const addToCart = () => {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            })
              .then(response => response.json())
              .then(() => {
                if (_this.el.podsSelector.formBtn !== null) {
                  _this.el.podsSelector.formBtn.disabled = false;
                  _this.el.podsSelector.formBtn.classList.remove('mt-btn--loading');
                }

                app.dl.addedToCart(...productsToAdd);
                window.top.location = window.Shopify.routes.root + 'cart';
              })
              .catch((error) => {
                console.error('Error:', error);
                if (_this.el.podsSelector.formBtn !== null) {
                  _this.el.podsSelector.formBtn.disabled = false;
                  _this.el.podsSelector.formBtn.classList.remove('mt-btn--loading');
                }
                window.top.location.reload();
              });
          };

          if (app.discounts.hasMembership(formData.items)) {
            app.discounts.apply(app.discounts.membershipDiscountCode, addToCart);
          } else {
            addToCart();
          }
        }
      });
    },

    updateVariant: function () {
      const _this = app.productPage;
      _this.el.whatsInBundle = document.querySelector('.mt-whats-in-bundle');

      let productUrl = window.location.origin + window.location.pathname + window.location.search + (window.location.search ? `&sections=${_this.el.section.dataset.section}` : `?sections=${_this.el.section.dataset.section}`);
      _this.el.whatsInBundle && (productUrl += `,${_this.el.whatsInBundle.dataset.section}`);

      _this.el.podsSelector.details.classList.add('loading');

      fetch(productUrl)
        .then(res => res.json())
        .then(res => {
          const productSection = document.createElement('div');
          productSection.innerHTML = res[_this.el.section.dataset.section];
          _this.el.whatsInBundle && (productSection.innerHTML += res[_this.el.whatsInBundle.dataset.section]);

          const sections = {
            prices: productSection.querySelector('.mt-product__prices'),
            details: productSection.querySelector('.mt-pods__details'),
            detailsSummary: productSection.querySelector('.mt-pods-step--pods .mt-pods-step__summary-info'),
            staticGallery: productSection.querySelector('.mt-product-static-gallery'),
            whatsInBundle: productSection.querySelector('.mt-whats-in-bundle')
          };

          // Update view
          _this.el.staticGallery.innerHTML = sections.staticGallery.innerHTML;
          _this.el.podsSelector.details.innerHTML = sections.details.innerHTML;
          _this.el.podsSelector.detailsSummary.innerHTML = sections.detailsSummary.innerHTML;
          if (_this.el.whatsInBundle) {
            if (sections.whatsInBundle) {
              _this.el.whatsInBundle.innerHTML = sections.whatsInBundle.innerHTML;
              _this.el.whatsInBundle.classList.remove('hidden');
              app.productInBundle.init();
            } else {
              _this.el.whatsInBundle.classList.add('hidden');
            }
          }

          // Update price
          _this.el.mainPrices.dataset.price = sections.prices.dataset.price;
          _this.el.mainPrices.dataset.compareAtPrice = sections.prices.dataset.compareAtPrice;
          _this.podsSelector.updatePrice();

          _this.el.podsSelector.details.classList.remove('loading');
        });
    },

    updatePrice: function () {
      const _this = app.productPage;
      const withDecimals = window.Shopify.money_format;
      let pricesHtml = '';
      let price = Number(_this.el.mainPrices.dataset.price);
      let compareAtPrice = (_this.el.mainPrices.dataset.compareAtPrice != 'undefined') ? Number(_this.el.mainPrices.dataset.compareAtPrice) : price;

      // Membership
      _this.el.podsSelector.membershipsOption.forEach(option => {
        if (option.checked && option.dataset.price) {
          price += Number(option.dataset.price);
          compareAtPrice += option.dataset.compareAtPrice ? Number(option.dataset.compareAtPrice) : Number(option.dataset.price);
        }
      });

      // Accessories & Courses
      [..._this.el.podsSelector.accessoriesItems, ..._this.el.podsSelector.coursesItems].forEach(item => {
        if (item.classList.contains('active')) {
          const itemQuantityEl = item.querySelector('.mt-quantity__input');
          const itemQuantity = Number(itemQuantityEl.value);
          const itemPrice = Number(itemQuantityEl.dataset.virtualPrice || itemQuantityEl.dataset.price);
          const itemOriginalPrice = Number(itemQuantityEl.dataset.price);
          price += itemPrice * itemQuantity;
          compareAtPrice += itemQuantityEl.dataset.compareAtPrice
            ? (Number(itemQuantityEl.dataset.compareAtPrice) * itemQuantity)
            : (itemOriginalPrice * itemQuantity);
        }
      });
      
      // Price rounding
      if (_this.el.podsSelector.form.dataset.priceRounding == 'true') {
        price = (price > 100) ? (Math.ceil(price / 100) * 100) : price;
        compareAtPrice = (compareAtPrice > 100) ? (Math.ceil(compareAtPrice / 100) * 100) : compareAtPrice;
      }

      // Update view
      if (compareAtPrice > price) {
        pricesHtml = `<span class="mt-price mt-price--sale">${Shopify.formatMoney(price, withDecimals).replace('.00', '')}</span><s class="mt-price mt-price--old">${Shopify.formatMoney(compareAtPrice, withDecimals).replace('.00', '')}</s>`;
      } else {
        pricesHtml = `<span class="mt-price">${Shopify.formatMoney(price, withDecimals).replace('.00', '')}</span>`;
      }
      _this.el.mainPrices.dataset.totalPrice = price;
      _this.el.mainPrices.dataset.totalCompareAtPrice = compareAtPrice;
      _this.el.prices.forEach(priceEl => (priceEl.innerHTML = pricesHtml));
      app.productPage.updateAffirmPrice();
    },

    init: function () {
      const _this = app.productPage;
      if (!_this.el.podsSelector.form) return;

      // Pods
      _this.el.podsSelector.options.forEach(option => {
        option.addEventListener('change', () => {
          const choose = _this.el.podsSelector.step.pods.querySelector('.mt-pods-step__choose span');
          choose.innerHTML = option.dataset.title;
          if (history.replaceState) {
            const currentUrl = new URL(window.top.location.href);
            const searchParams = currentUrl.searchParams;
            searchParams.set('variant', option.value);
            currentUrl.search = searchParams.toString();
            history.replaceState({}, null, currentUrl.toString());
            _this.podsSelector.updateVariant();
          }
        });
      });

      // Toggle membership details
      _this.el.podsSelector.membershipsToggle.forEach(el => {
        const plan = el.closest('.mt-pods-membership');
        el.addEventListener('click', e => {
          e.preventDefault();
          _this.el.podsSelector.memberships.forEach(memb => memb !== plan && memb.classList.remove('active'));
          plan.classList.toggle('active');
        });
      });

      // Membership options
      _this.el.podsSelector.membershipsOption.forEach(option => {
        option.addEventListener('change', () => {
          const membership = option.closest('.mt-pods-membership');
          const choose = _this.el.podsSelector.step.memberships.querySelector('.mt-pods-step__choose span');
          choose.innerHTML = option.dataset.title;
          _this.el.podsSelector.btn.memberships.disabled = false;
          _this.el.podsSelector.memberships.forEach(el => (el === membership) ? el.classList.add('mt-pods-membership--selected') : el.classList.remove('mt-pods-membership--selected'));
          _this.podsSelector.updatePrice();
        });
      });

      // Accessories
      if (_this.el.podsSelector.accessories && _this.el.podsSelector.accessoriesItems.length > 0) {
        _this.el.podsSelector.accessoriesItems.forEach(item => {
          const itemImage = item.querySelector('.mt-accessories__item-image');
          const itemQuantity = item.querySelector('.mt-quantity__input');
          const itemDesc = {
            el: item.querySelector('.mt-accessories__item-description'),
            primary: item.querySelector('.mt-accessories__item-description-primary'),
            secondary: item.querySelector('.mt-accessories__item-description-secondary')
          };
          item.addEventListener('click', e => {
            if (e.target.classList.contains('mt-quantity') || e.target.closest('.mt-quantity')) return;
            if (item.classList.contains('active')) {
              item.classList.remove('active');
              itemImage.removeAttribute('data-quantity');
            } else {
              item.classList.add('active');
              (Number(itemQuantity.value) > 1) && itemImage.setAttribute('data-quantity', `x${itemQuantity.value}`);
            }

            const activeProducts = document.querySelectorAll('.mt-accessories__item.active').length;
            const choose = _this.el.podsSelector.step.accessories.querySelector('.mt-pods-step__choose span');
            if (activeProducts > 0) {
              _this.el.podsSelector.step.accessories.classList.add('completed');
              choose.innerHTML = `${activeProducts} ${(activeProducts > 1) ? 'Accessories' : 'Accessory'}`;
            } else {
              _this.el.podsSelector.step.accessories.classList.remove('completed');
              choose.innerHTML = '';
            }
            _this.podsSelector.updatePrice();
          });
          itemQuantity.addEventListener('change', () => {
            const quantity = Number(itemQuantity.value);
            if (quantity == 0) {
              itemImage.removeAttribute('data-quantity');
              item.classList.remove('active');
              itemQuantity.value = 1;
            } else if (quantity > 1) {
              itemImage.setAttribute('data-quantity', `x${quantity}`);
            } else {
              itemImage.removeAttribute('data-quantity');
            }
            _this.podsSelector.updatePrice();
          });

          // Update description element
          const updateItemDescription = () => {
            if (itemDesc.primary || itemDesc.secondary) {
              let itemDescType = 'list';
              let itemHeight = 0;
              if (itemDesc.primary) {
                itemDescType = 'list';
                itemHeight = itemDesc.primary.offsetHeight;
              }
              if (itemDesc.secondary && itemDesc.secondary.offsetHeight > itemHeight) {
                itemDescType = 'text';
                itemHeight = itemDesc.secondary.offsetHeight;
              }

              itemDesc.el.classList.remove('mt-accessories__item-description--list');
              itemDesc.el.classList.remove('mt-accessories__item-description--text');
              itemDesc.el.classList.add(`mt-accessories__item-description--${itemDescType}`);
              itemDesc.el.style.setProperty('--min-height', `${itemHeight}px`);
            }
          }
          updateItemDescription();
          window.addEventListener('resize', updateItemDescription);
          window.addEventListener('touchstart', updateItemDescription);
        });
      }

      // Courses
      if (_this.el.podsSelector.courses && _this.el.podsSelector.coursesItems.length > 0) {
        _this.el.podsSelector.coursesItems.forEach(item => {
          item.addEventListener('click', e => {
            if (item.classList.contains('active')) {
              item.classList.remove('active');
            } else {
              item.classList.add('active');
            }

            const activeProducts = document.querySelectorAll('.mt-courses__item.active').length;
            const choose = _this.el.podsSelector.step.courses.querySelector('.mt-pods-step__choose span');
            if (activeProducts > 0) {
              _this.el.podsSelector.step.courses.classList.add('completed');
              choose.innerHTML = `${activeProducts} ${(activeProducts > 1) ? 'Courses' : 'Course'}`;
            } else {
              _this.el.podsSelector.step.courses.classList.remove('completed');
              choose.innerHTML = '';
            }
            _this.podsSelector.updatePrice();
          });
        });
      }

      // Step controls
      if (_this.el.podsSelector.step.all.length > 0) {
        _this.el.podsSelector.step.all.forEach(step => {
          const summary = step.querySelector('summary');
          summary.addEventListener('click', () => {
            if (step.getAttribute('open') === null) {
              _this.el.podsSelector.step.all.forEach(s => step !== s && s.removeAttribute('open'));
              step.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            }
          });
        });
      }
      if (_this.el.podsSelector.btn.pods) {
        _this.el.podsSelector.btn.pods.addEventListener('click', e => {
          e.preventDefault();
          _this.el.podsSelector.step.pods.classList.add('completed');
          _this.el.podsSelector.step.pods.removeAttribute('open');
          _this.el.podsSelector.step.memberships.setAttribute('open', '');
          _this.el.podsSelector.step.memberships.removeAttribute('disabled');
          _this.podsSelector.currentStep = 2;
        });
      }
      if (_this.el.podsSelector.btn.memberships) {
        _this.el.podsSelector.btn.memberships.addEventListener('click', e => {
          e.preventDefault();
          _this.el.podsSelector.step.memberships.classList.add('completed');
          _this.el.podsSelector.step.memberships.removeAttribute('open');
          _this.el.podsSelector.step.accessories.setAttribute('open', '');
          _this.el.podsSelector.step.accessories.removeAttribute('disabled');
          _this.el.podsSelector.formBtn.removeAttribute('disabled');
          _this.el.stickyProductFormBtn.removeAttribute('disabled');
          _this.podsSelector.currentStep = 3;
        });
      }

      // Main form
      _this.podsSelector.updatePrice();
      _this.podsSelector.form();
    }
  },

  variantSelector: {
    variants: window.Shopify.productVariants,

    updatePage: function(variant = null) {
      const _this = app.productPage;
      if (variant === null) return;

      // Update product data & ID
      if (_this.el.productFormId) {
        const productData = JSON.parse(_this.el.productFormId.dataset.product);
        productData.variant_id = variant.id;
        productData.variant = variant.title;
        productData.sku = variant.sku;
        productData.price = variant.price / 100;
        _this.el.productFormId.dataset.product = JSON.stringify(productData);
        _this.el.productFormId.value = variant.id;
      }

      // Update selling plan
      const sellingPlanInput = _this.el.productForm.querySelector('input[name="selling_plan"]');
      const planId = variant.selling_plan_allocations?.[0]?.selling_plan_id;
      if (sellingPlanInput && planId) {
        sellingPlanInput.value = planId;
      }

      // Update price
      let price = variant.price;
      let compareAtPrice = variant.compare_at_price;

      if (variant.bundle_discount) {
        price = Math.round(price * (100 - variant.bundle_discount) / 100);
        compareAtPrice = variant.price;
      }
      
      _this.el.mainPrices.dataset.price = price;
      (compareAtPrice && compareAtPrice > price) ? (_this.el.mainPrices.dataset.compareAtPrice = compareAtPrice) : _this.el.mainPrices.removeAttribute('data-compare-at-price');
      _this.updatePrice();

      // Update ATC
      _this.el.productFormBtn && (_this.el.productFormBtn.dataset.available = variant.available);
      _this.el.stickyProductForm && (_this.el.stickyProductForm.dataset.available = variant.available);

      // Update BIS
      if (_this.el.bisSection && _this.el.bisVariant) {
        _this.el.bisVariant.value = variant.id;
        _this.el.bisSection.classList.toggle('hidden', variant.available);
      }

      (typeof initializePromos == 'function') && initializePromos();
    },

    getCurrentVariant: function() {
      const _this = this;
      const productOptions = app.productPage.el.productForm.querySelectorAll('.mt-product-option__list input');
      if (productOptions && productOptions.length === 0) return;

      const selectedOptions = [...productOptions].filter(o => o.checked).map(o => o.value);
      const variant = _this.variants.find(v => v.options.every(o => selectedOptions.includes(o))) || null;

      if (variant) {
        const discountData = window.Shopify.variantDiscounts;
        if (discountData) {
          variant.bundle_discount = discountData.variants[variant.id] || discountData.product_discount;
        }
      }

      return variant;
    },

    init: function() {
      const _this = this;

      if (app.productPage.el.variantSelector.options.length === 0) return;
    
      app.productPage.el.variantSelector.options.forEach(option => {
        option.addEventListener('change', () => {
          const sameOptions = document.querySelectorAll(`.mt-product input[name="${option.name}"][value="${option.value}"]`);
          (sameOptions.length > 0) && sameOptions.forEach(o => (o.checked = option.checked));
          const currentVariant = _this.getCurrentVariant();
          if (currentVariant !== null) {
            if (history.replaceState) {
              const currentUrl = new URL(window.top.location.href);
              const searchParams = currentUrl.searchParams;
              searchParams.set('variant', currentVariant.id);
              currentUrl.search = searchParams.toString();
              history.replaceState({}, null, currentUrl.toString());
            }
            _this.updatePage(currentVariant);
          }
        });
      });
    }
  },

  sizeGuide: {
    el: {
      switcher: document.querySelector('.mt-modal--size-guide .mt-switcher'),
      table: document.querySelector('.mt-size-guide__table table')
    },

    reCalculate: function(unit = null) {
      const { el } = this;
      if (!el.switcher || !el.table) return;
      (unit === null) && (unit = el.switcher.dataset.active);

      const cells = el.table.querySelectorAll('td');
      cells.forEach(cell => {
        const values = { cm: cell.dataset.cm, inch: cell.dataset.inch };
        if (!values.cm || !values.inch) return;
        cell.innerText = values[unit];
      });
    },

    init: function() {
      const _this = this;
      if (!_this.el.switcher) return;

      _this.el.switcher.addEventListener('click', e => {
        const currentUnit = _this.el.switcher.dataset.active;
        let newUnit = currentUnit;

        if (e.target.classList.contains('mt-switcher__toggle')) {
          newUnit = (currentUnit == 'cm') ? 'inch' : 'cm';
        } else if (e.target.classList.contains('mt-switcher__option')) {
          newUnit = e.target.dataset.option;
        }

        if (currentUnit !== newUnit) {
          _this.el.switcher.dataset.active = newUnit;
          _this.reCalculate(newUnit);
        }
      });
    }
  },

  init: function () {
    const _this = this;
    if (_this.el.section === undefined) return;

    // Update price (if offer)
    _this.updatePrice();

    // Product gallery - optional shared gallery additions, injected elsewhere on the page as
    // <script data-alt-gallery> (see sections/media-gallery-json.liquid). When present, items are
    // appended after the product's own (already rendered) gallery media.
    if (_this.el.mainGallery && _this.el.thumbs) {
      const altDataEl = document.querySelector('[data-alt-gallery]');
      const raw = altDataEl && altDataEl.textContent.split('').filter(function (ch) { return ch.charCodeAt(0) >= 32; }).join('').trim();
      const wrapperData = (_this.el.galleryWrapper && _this.el.galleryWrapper.dataset) || {};
      if (raw) {
        try {
          const items = JSON.parse(raw);
          if (Array.isArray(items) && items.length > 0) {
            const galleryWrapper = _this.el.mainGallery.querySelector('.swiper-wrapper');
            const thumbsWrapper = _this.el.thumbs.querySelector('.swiper-wrapper');
            const existingCount = galleryWrapper.querySelectorAll('.swiper-slide').length;

            const escapeAttr = (str) => String(str || '').replace(/"/g, '&quot;');

            const mainMediaMarkup = (item) => {
              if (item.type === 'video') {
                const poster = item.thumbnail ? ` poster="${escapeAttr(item.thumbnail)}"` : '';
                return `<video src="${escapeAttr(item.url)}"${poster} controlslist="nodownload" disablepictureinpicture playsinline webkit-playsinline></video>`;
              }
              if (item.type === 'external_video') {
                return `<iframe src="${escapeAttr(item.url)}" title="${escapeAttr(item.alt)}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen frameborder="0"></iframe>`;
              }
              return `<div class="swiper-zoom-container"><img src="${escapeAttr(item.url)}" alt="${escapeAttr(item.alt)}" loading="lazy"></div>`;
            };

            galleryWrapper.insertAdjacentHTML('beforeend', items.map((item, i) => `
              <div class="swiper-slide" data-slide="${existingCount + i}" data-media-type="${escapeAttr(item.type)}"${item.type !== 'image' ? ' data-video-media' : ''}>
                <div class="mt-product-gallery__item">${mainMediaMarkup(item)}</div>
              </div>
            `).join(''));

            const existingZoomBtn = _this.el.mainGallery.querySelector('.mt-gallery-zoom-btn');
            if (existingZoomBtn) existingZoomBtn.setAttribute('aria-label', wrapperData.zoomLabel || '');

            thumbsWrapper.insertAdjacentHTML('beforeend', items.map((item, i) => `
              <div class="swiper-slide" data-slide="${existingCount + i}"${item.type !== 'image' ? ' data-video-media' : ''} role="button" tabindex="0" aria-label="${escapeAttr(item.alt)}">
                <div class="mt-product-thumbs__item" data-type="${item.type === 'image' ? 'image' : item.type}">
                  <img src="${escapeAttr(item.type === 'image' ? item.url : (item.thumbnail || item.url))}" alt="${escapeAttr(item.alt)}" loading="lazy">
                </div>
              </div>
            `).join(''));

            _this.el.thumbItems = thumbsWrapper.querySelectorAll('.swiper-slide');

            const showVideoButton = wrapperData.showVideoButton === 'true';
            const firstVideoIndex = items.findIndex((item) => item.type === 'video' || item.type === 'external_video');
            if (showVideoButton && firstVideoIndex !== -1) {
              const label = wrapperData.videoButtonLabel || '';
              const absoluteVideoIndex = existingCount + firstVideoIndex;
              const videoBtnHtml = (targetIndex) => `
                <button type="button" class="mt-gallery-video-btn" data-video-slide="${targetIndex}" aria-label="${escapeAttr(label)}">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="24" height="24" viewBox="0 0 24 24" class="mt-icon mt-icon--play-circle">
                    <circle cx="11.772" cy="11.772" r="10.843" stroke="currentColor" stroke-width="1.859"/>
                    <path fill="currentColor" d="M15.797 11.546a.62.62 0 0 1 0 1.073l-6.04 3.488a.62.62 0 0 1-.93-.537V8.594a.62.62 0 0 1 .93-.536z"/>
                  </svg>
                  <span>${escapeAttr(label)}</span>
                </button>
              `;
              const galleryItems = galleryWrapper.querySelectorAll('.mt-product-gallery__item');
              const firstSlideItem = galleryItems[0];
              if (firstSlideItem && !firstSlideItem.querySelector('.mt-gallery-video-btn')) {
                firstSlideItem.insertAdjacentHTML('beforeend', videoBtnHtml(absoluteVideoIndex));
              }

              if (items[firstVideoIndex].type === 'video' && absoluteVideoIndex !== 0) {
                const videoSlideItem = galleryItems[absoluteVideoIndex];
                if (videoSlideItem) videoSlideItem.insertAdjacentHTML('beforeend', videoBtnHtml(absoluteVideoIndex));
              }
            }

            // Nav arrows/thumbs start hidden in markup if the product's own media alone didn't
            // warrant them (see sections/main-mt-product.liquid) - reveal them now that extra
            // slides from the shared gallery pushed the final count over the threshold.
            const finalCount = existingCount + items.length;
            if (_this.el.thumbButtons) {
              _this.el.thumbButtons.forEach(btn => btn.classList.toggle('is-hidden', finalCount <= 4));
            }
            const pagination = _this.el.mainGallery.querySelector('.swiper-pagination');
            if (pagination) pagination.classList.toggle('is-hidden', finalCount <= 1);
          }
        } catch (e) {
          console.error('Invalid alternative gallery JSON', e);
        }
      }
    }

    // Product gallery - move video media to slide 7 (or last, whichever comes first) on desktop
    if (_this.el.mainGallery && _this.el.thumbs && window.innerWidth >= 992) {
      const videoSlide = _this.el.mainGallery.querySelector('.swiper-slide[data-video-media]');
      const videoThumb = _this.el.thumbs.querySelector('.swiper-slide[data-video-media]');
      if (videoSlide && videoThumb) {
        const galleryWrapper = _this.el.mainGallery.querySelector('.swiper-wrapper');
        const thumbsWrapper = _this.el.thumbs.querySelector('.swiper-wrapper');
        const maxIndex = 6;

        const reorderVideoSlide = (wrapper, videoEl) => {
          const others = Array.from(wrapper.querySelectorAll('.swiper-slide')).filter(el => el !== videoEl);
          if (maxIndex >= others.length) {
            wrapper.appendChild(videoEl);
          } else {
            wrapper.insertBefore(videoEl, others[maxIndex]);
          }
        };
        reorderVideoSlide(galleryWrapper, videoSlide);
        reorderVideoSlide(thumbsWrapper, videoThumb);

        const gallerySlides = galleryWrapper.querySelectorAll('.swiper-slide');
        gallerySlides.forEach((slide, i) => { slide.dataset.slide = i; });
        thumbsWrapper.querySelectorAll('.swiper-slide').forEach((thumb, i) => { thumb.dataset.slide = i; });
        _this.el.thumbItems = thumbsWrapper.querySelectorAll('.swiper-slide');

        const newVideoIndex = Array.from(gallerySlides).indexOf(videoSlide);
        _this.el.mainGallery.querySelectorAll('.mt-gallery-video-btn').forEach(btn => { btn.dataset.videoSlide = newVideoIndex; });
      }
    }

    // Product gallery - sliders
    if (_this.el.thumbs) {
      const isCompact = _this.el.section && _this.el.section.classList.contains('mt-product--compact');
      _this.slider.thumbs = new Swiper(_this.el.thumbs, {
        direction: 'horizontal',
        slidesPerView: isCompact ? 4.5 : 'auto',
        spaceBetween: isCompact ? 4 : 10,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.mt-product-thumbs__button--next',
          prevEl: '.mt-product-thumbs__button--prev',
        },
        breakpoints: {
          450: {
            slidesPerView: 'auto',
          },
          1200: {
            direction: 'vertical',
            slidesPerView: isCompact ? 5 : 4,
            spaceBetween: isCompact ? 6 : 8,
          },
          1400: {
            direction: 'vertical',
            slidesPerView: isCompact ? 7 : 4,
            spaceBetween: isCompact ? 6 : 8,
          }
        }
      });
    }
    if (_this.el.mainGallery) {
      const zoomEnabled = _this.el.mainGallery.dataset.enableZoom === 'true';
      _this.slider.main = new Swiper(_this.el.mainGallery, {
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        zoom: zoomEnabled ? {
          maxRatio: 2,
          minRatio: 1,
        } : false,
        thumbs: {
          swiper: _this.slider.thumbs
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          450: {
            spaceBetween: -5,
          },
          768: {
            spaceBetween: 5,
          }
        }
      });
      if (zoomEnabled) {
        _this.el.mainGallery.addEventListener('click', (e) => {
          if (e.target.closest('.mt-gallery-zoom-btn')) _this.slider.main.zoom.toggle();
        });
        const zoomBtn = _this.el.mainGallery.querySelector('.mt-gallery-zoom-btn');
        _this.slider.main.on('zoomChange', (swiper, scale) => {
          if (zoomBtn) zoomBtn.classList.toggle('is-zoomed', scale > 1);
        });
        if (zoomBtn) {
          const updateZoomBtnVisibility = (activeIndex) => {
            const slide = _this.slider.main.slides[activeIndex];
            zoomBtn.classList.toggle('is-hidden', !slide || slide.dataset.mediaType !== 'image');
          };
          updateZoomBtnVisibility(_this.slider.main.activeIndex);
          _this.slider.main.on('slideChange', function () { updateZoomBtnVisibility(this.activeIndex); });
        }
      }
    }
    const playSlideVideo = (slide) => {
      if (!slide) return;
      const video = slide.querySelector('video');
      if (video) {
        video.volume = 0.35;
        video.controls = true;
        if (window.innerWidth >= 992) video.focus();
        video.play();
      }
      const iframe = slide.querySelector('iframe');
      if (iframe && iframe.src) {
        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      }
      const videoBtn = slide.querySelector('.mt-gallery-video-btn');
      if (videoBtn) videoBtn.classList.add('is-hidden');
    };

    if (_this.el.thumbItems.length > 0) {
      _this.el.thumbItems.forEach(thumb => {
        const index = Number(thumb.dataset.slide);
        const isVideoThumb = thumb.hasAttribute('data-video-media');
        const goToSlide = () => _this.slider.main.slideTo(index, 0);
        const selectSlide = () => {
          goToSlide();
          if (isVideoThumb) playSlideVideo(_this.slider.main.slides[index]);
        };
        thumb.addEventListener('mouseenter', () => { if (window.innerWidth >= 992) goToSlide(); });
        thumb.addEventListener('click', selectSlide);
        thumb.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectSlide(); }
        });
      });
    }
    if (_this.slider.main && _this.slider.thumbs) {
      const updateThumbAriaCurrent = (activeIndex) => {
        _this.el.thumbItems.forEach((t, i) => {
          t.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
          t.classList.toggle('swiper-slide-thumb-active', i === activeIndex);
        });
      };
      updateThumbAriaCurrent(_this.slider.main.activeIndex);

      _this.slider.main.on('slideChange', function () {
        updateThumbAriaCurrent(this.activeIndex);

        this.slides.forEach(function (slide) {
          var video = slide.querySelector('video');
          if (video && !video.paused) video.pause();
          var iframe = slide.querySelector('iframe');
          if (iframe && iframe.src) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });

        if (window.innerWidth >= 1200) return;

        const activeIndex = this.activeIndex;
        const thumbSwiper = _this.slider.thumbs;
        const slide = thumbSwiper.slides[activeIndex];
        if (!slide) return;

        const swiperWidth = thumbSwiper.width;
        const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
        let translateX = (swiperWidth / 2) - slideCenter;

        const maxTranslate = thumbSwiper.maxTranslate();
        const minTranslate = thumbSwiper.minTranslate();

        if (translateX > minTranslate) translateX = minTranslate;
        if (translateX < maxTranslate) translateX = maxTranslate;

        thumbSwiper.setTransition(300);
        thumbSwiper.setTranslate(translateX);
        thumbSwiper.updateActiveIndex();
      });
    }
    if (_this.el.thumbButtons.length > 0) {
      _this.el.thumbButtons.forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();
          (button.classList.contains('mt-product-thumbs__button--prev')) ? _this.slider.thumbs.slidePrev() : _this.slider.thumbs.slideNext();
        });
      });
    }

    if (_this.el.mainGallery && _this.slider.main) {
      _this.el.mainGallery.querySelectorAll('.mt-gallery-video-btn').forEach(videoBtn => {
        videoBtn.addEventListener('click', () => {
          const targetIndex = parseInt(videoBtn.dataset.videoSlide, 10);
          _this.slider.main.slideTo(targetIndex);
          playSlideVideo(_this.slider.main.slides[targetIndex]);
        });
      });
    }

    // Accordions
    if (_this.el.accordions.length > 0 && _this.el.accordionTabs.length > 0) {
      _this.el.accordions.forEach(accordion => {
        const summary = accordion.querySelector('summary');
        const tab = [..._this.el.accordionTabs].filter(tab => tab.hash == `#${accordion.id}`)[0];
        summary.addEventListener('click', e => {
          e.preventDefault();
          _this.el.accordions.forEach(acc => acc !== accordion && acc.removeAttribute('open'));
          _this.el.accordionTabs.forEach(t => t !== tab && t.classList.remove('active'));
          tab.classList.toggle('active');
          accordion.toggleAttribute('open');
          accordion.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });
      _this.el.accordionTabs.forEach(tab => {
        const accordion = document.querySelector(tab.hash);
        tab.addEventListener('click', e => {
          e.preventDefault();
          _this.el.accordionTabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          _this.el.accordions.forEach(acc => acc.removeAttribute('open'));
          accordion.setAttribute('open', '');
        });
      });
    }

    // Pods selector
    _this.podsSelector.init();

    // Variant selector
    _this.variantSelector.init();

    // Size guide
    _this.sizeGuide.init();

    // Sticky product form
    if (_this.el.productForm && _this.el.stickyProductForm) {
      document.addEventListener('DOMContentLoaded', () => {
        const formButton = _this.el.productForm.querySelector('.mt-btn');
        const pageFooter = document.querySelector('.mt-footer-v2');
        const isCompactV2 = !!document.querySelector('.mt-product--compact-v2');
        const handleIntersection = () => {
          const buttonRect = formButton.getBoundingClientRect();
          const footerRect = pageFooter.getBoundingClientRect();
          const isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom >= 0;
          const isButtonVisible = isCompactV2
            ? buttonRect.bottom < 0
            : (buttonRect.top < window.innerHeight && buttonRect.bottom >= 0);

          _this.el.stickyProductForm.dataset.active = isCompactV2
            ? (isButtonVisible && !isFooterVisible)
            : !(isButtonVisible || isFooterVisible);
        };
        window.addEventListener('scroll', handleIntersection);
        handleIntersection();
      });
    }

    // Reviews
    if (_this.el.reviewsSummary) {
      _this.el.reviewsSummary.addEventListener('click', e => {
        e.preventDefault();
        const reviewsSection = document.querySelector('#yotpo-reviews-main-widget');
        reviewsSection && reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Events
    const currentProduct = document.querySelector('.mt-product .mt-product-form input[name="id"], .mt-pods__option input:checked');
    if (currentProduct) {
      const viewItemWhenAvailable = () => {
        const viwaId = setInterval(() => {
          if (window.app && window.app.dl && typeof window.app.dl.viewItem === 'function') {
            clearInterval(viwaId);
            window.app.dl.viewItem(currentProduct.dataset.product);
          }
        }, 100);
      };
      viewItemWhenAvailable();
    }

    // Custom CTA
    if (_this.el.title) {
      _this.el.customBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          app.dl.ctaClick(_this.el.title.innerText, { location: 'Course' });
        });
      });
    }
  }
}
window.app.productPage.init();

window.app.productInBundle = {
  init: function () {
    const items = window.app.whatsInsideExtras;
    if (!items || items.length === 0) return;

    document.querySelectorAll('[data-whats-inside] .mt-accordion__content-inner ul:not([data-extras])').forEach(list => {
      items.forEach(item => {
        const li = document.createElement('li');
        li.className = 'metafield-single_line_text_field';
        li.textContent = item.title;
        list.appendChild(li);
      });
      list.dataset.extras = 'true';
    });

    document.querySelectorAll('.mt-whats-in-bundle__list:not([data-extras])').forEach(list => {
      items.forEach(item => {
        const el = document.createElement('div');
        el.className = 'mt-whats-in-bundle__item';
        el.innerHTML = `
          <div class="mt-whats-in-bundle__item-content">
            ${item.image ? `<div class="mt-whats-in-bundle__item-image"><img src="${item.image}" width="${item.width}" height="${item.height}" alt="" loading="lazy"></div>` : ''}
            <p class="mt-whats-in-bundle__item-title"></p>
          </div>`;
        el.querySelector('.mt-whats-in-bundle__item-title').textContent = item.title;
        list.appendChild(el);
      });
      list.dataset.extras = 'true';
    });
  }
};
window.app.productInBundle.init();
